import { nodeEnv, userPermission, } from '@/constants';
import { getGlobalStore } from '@/lib/global-store';
import permissionList from '@/constants/userPermission';
import { userGetterType } from '@/vuex-store/user/getters';
import { routeName } from '../routeName';
const vuexStore = getGlobalStore();
const menuList = () => [
    {
        title: 'control',
        children: [
            // 지도관제는 목록관제 안으로..
            {
                title: 'map_control',
                linkOptions: {
                    to: {
                        name: routeName.MAP_CONTROL,
                    },
                    popup: true,
                },
            },
            {
                debug: true,
                title: 'list_control',
                linkOptions: {
                    to: {
                        name: routeName.LIST_CONTROL,
                    },
                },
            },
            {
                title: 'delivery_history',
                linkOptions: {
                    to: {
                        name: routeName.DELIVERY_HISTORY,
                    },
                },
            },
            // {
            //   title: 'operation_setting',
            //   linkOptions: {
            //     to: {
            //       name: routeName.OPERATION_SETTING,
            //     },
            //   },
            // },
            {
                title: 'operation_setting',
                linkOptions: {
                    to: {
                        name: routeName.OPERATION_SETTING,
                    },
                },
            },
        ],
    },
    {
        title: 'store',
        children: [
            {
                title: 'store_management',
                linkOptions: {
                    to: {
                        name: routeName.STORE_MANAGEMENT,
                    },
                    pageAuthorization: userPermission.P_GET_STORE(),
                },
            },
            {
                // TODO v0.7.0배포 전이므로 상점정산 메뉴 감추기, 배포 시 수정 필요
                title: 'store_adjustment',
                linkOptions: {
                    to: {
                        name: routeName.STORE_ADJUSTMENT,
                    },
                    pageAuthorization: [
                        userPermission.P_GET_STORE_ADJUSTMENT,
                    ],
                },
            },
            {
                debug: true,
                title: 'store_stats',
                linkOptions: {
                    to: {
                        name: routeName.STORE_STATS,
                    },
                    pageAuthorization: [
                        permissionList.P_GET_STORE_STATS,
                    ],
                },
            },
        ],
    },
    {
        title: 'worker',
        children: [
            {
                title: 'worker_management',
                linkOptions: {
                    to: {
                        name: routeName.WORKER_MANAGEMENT,
                    },
                    pageAuthorization: userPermission.P_GET_WORKER(),
                },
            },
            // 바로머니 내역
            {
                title: 'worker_baromoney_history',
                linkOptions: {
                    to: {
                        name: routeName.WORKER_BAROMONEY_HISTORY,
                    },
                    pageAuthorization: userPermission.P_GET_WORKER(),
                },
            },
            // 수익
            {
                title: 'worker_profit',
                linkOptions: {
                    to: {
                        name: routeName.WORKER_PROFIT,
                    },
                    pageAuthorization: userPermission.P_GET_WORKER(),
                },
            },
            {
                title: 'worker_monthly_attendance',
                linkOptions: {
                    to: {
                        name: routeName.WORKER_MONTHLY_ATTENDANCE,
                    },
                    pageAuthorization: userPermission.P_GET_WORKER(),
                },
            },
            {
                title: 'worker_adjustment',
                linkOptions: {
                    to: {
                        name: routeName.WORKER_ADJUSTMENT,
                    },
                    pageAuthorization: [
                        userPermission.P_GET_WORKER_ADJUSTMENT,
                    ],
                },
            },
        ],
    },
    {
        title: 'hub',
        children: [
            {
                title: 'hub_management',
                linkOptions: {
                    to: {
                        name: routeName.HUB_MANAGEMENT,
                    },
                    pageAuthorization: userPermission.P_GET_HUB(),
                },
            },
            {
                title: 'hub_adjustment',
                linkOptions: {
                    to: {
                        name: routeName.HUB_ADJUSTMENT,
                    },
                    pageAuthorization: [
                        permissionList.P_GET_HUB_SALES,
                    ],
                },
            },
            {
                debug: true,
                title: 'hub_adjustment_test_mode_entrance',
                linkOptions: {
                    to: {
                        name: routeName.HUB_ADJUSTMENT_TEST_MODE_ENTRANCE,
                    },
                    pageAuthorization: [
                        permissionList.P_GET_HUB_SALES,
                    ],
                },
            },
            {
                debug: true,
                title: 'hub_stats',
                linkOptions: {
                    to: {
                        name: routeName.HUB_STATS,
                    },
                    // pageAuthorization: [
                    // ],
                },
            },
        ],
    },
    // 정책관리
    {
        title: 'policy',
        children: [
            {
                title: 'user_management',
                linkOptions: {
                    to: {
                        name: routeName.USER_MANAGEMENT,
                    },
                    pageAuthorization: userPermission.P_GET_USER_LIST(),
                },
            },
            // {
            //   debug: true,
            //   title: 'policy_delivery_amount',
            //   linkOptions: {
            //     to: {
            //       name: routeName.POLICY_DELIVERY_AMOUNT,
            //     },
            //     // pageAuthorization: [
            //     // ],
            //   },
            // },
            {
                isOnlyForDistributorUser: true,
                title: 'share_management',
                linkOptions: {
                    to: {
                        name: routeName.SHARE_MANAGEMENT,
                    },
                    pageAuthorization: userPermission.P_GET_SHARE_MANAGEMENT(),
                    isSomePermissionAvailable: true,
                },
            },
            {
                title: 'delivery_charge_area_control',
                linkOptions: {
                    to: {
                        name: routeName.DELIVERY_CHARGE_AREA_CONTROL,
                    },
                },
            },
        ],
    },
    {
        title: 'sales',
        linkOptions: {
            to: {
                name: routeName.SALES,
            },
        },
    },
    {
        title: 'baromoney_report',
        linkOptions: {
            to: {
                name: routeName.BAROMONEY_REPORT,
            },
            pageAuthorization: [
                userPermission.P_GET_HUB_SALES,
            ],
        },
    },
    {
        title: 'notice',
        children: [
            // 바로고 공지사항
            {
                debug: true,
                title: 'barogo_notice',
                linkOptions: {
                    to: {
                        name: routeName.BAROGO_NOTICE,
                    },
                },
            },
            // 회원사 업무문의
            {
                debug: true,
                title: 'member_company_inquiry',
                linkOptions: {
                    to: {
                        name: routeName.MEMBER_COMPANY_INQUIRY,
                    },
                },
            },
            // 총판점 공지사항
            {
                title: 'distributor_notice',
                linkOptions: {
                    to: {
                        name: routeName.DISTRIBUTOR_NOTICE,
                    },
                },
            },
            // 상점 업무처리 (가맹점 업무처리)
            {
                debug: true,
                title: 'store_work_process',
                linkOptions: {
                    to: {
                        name: routeName.STORE_WORK_PROCESS,
                    },
                },
            },
            // 라이더 공지사항 (기사 공지사항)
            {
                debug: true,
                title: 'worker_notice',
                linkOptions: {
                    to: {
                        name: routeName.WORKER_NOTICE,
                    },
                },
            },
            // 세부지명 요청
            {
                debug: true,
                title: 'request_map',
                linkOptions: {
                    to: {
                        name: routeName.REQUEST_MAP,
                    },
                },
            },
            // 정산서 다운로드
            {
                debug: true,
                title: 'report_download',
                linkOptions: {
                    to: {
                        name: routeName.REPORT_DOWNLOAD,
                    },
                },
            },
            // 바로머니 이동 설정 (캐쉬 이동 설정)
            {
                debug: true,
                title: 'baromoney_transfer_setting',
                linkOptions: {
                    to: {
                        name: routeName.BAROMONEY_TRANSFER_SETTING,
                    },
                },
            },
            // 바로머니 미수금 리스트
            {
                debug: true,
                title: 'baromoney_account_receivable_list',
                linkOptions: {
                    to: {
                        name: routeName.BAROMONEY_ACCOUNT_RECEIVABLE_LIST,
                    },
                },
            },
            // 바로머니 미지급 리스트
            {
                debug: true,
                title: 'baromoney_accrued_expenses_list',
                linkOptions: {
                    to: {
                        name: routeName.BAROMONEY_ACCRUED_EXPENSES_LIST,
                    },
                },
            },
        ],
    },
    {
        debug: true,
        title: 'temporary',
        linkOptions: {
            to: {
                name: routeName.TEMPORARY,
            },
            pageAuthorization: [
                userPermission.P_GET_TEMPORARY,
            ],
        },
    },
    {
        debug: true,
        title: 'design_system_text',
        linkOptions: {
            to: {
                name: routeName.DESIGN_SYSTEM_TEXT,
            },
        },
    },
    {
        debug: true,
        title: 'design_system_form',
        linkOptions: {
            to: {
                name: routeName.DESIGN_SYSTEM_FORM,
            },
            pageAuthorization: [
                userPermission.P_GET_TEMPORARY,
            ],
        },
    },
    {
        debug: true,
        title: 'design_system_button',
        linkOptions: {
            to: {
                name: routeName.DESIGN_SYSTEM_BUTTON,
            },
            pageAuthorization: [
                userPermission.P_GET_TEMPORARY,
            ],
        },
    },
];
export function initMenu() {
    const isDistUser = vuexStore.getters[userGetterType.isDistUser];
    return (menuList()
        // 1Depth Page에 대하여 debug 및 권한 체크
        .filter(({ debug }) => (debug ? process.env.VUE_APP_ENV !== nodeEnv.PRODUCTION : true))
        .filter(({ linkOptions }) => {
        // 1Depth에 링크옵션이 없으면 페이지가 아니므로 얼리 리턴
        if (!linkOptions) {
            return true;
        }
        const { pageAuthorization } = linkOptions;
        if (!pageAuthorization || !pageAuthorization.length) {
            return true;
        }
        if (vuexStore.getters['user/getterUserPermission'](pageAuthorization, true)) {
            return true;
        }
        return false;
    })
        // 2Depth debug 및 권한 체크
        .map((val) => ({
        ...val,
        children: val.children
            && val.children
                .filter(({ debug }) => (debug ? process.env.VUE_APP_ENV !== nodeEnv.PRODUCTION : true))
                // 총판 유저만 진입할 수 있는 페이지(예: 공유관리)의 경우 로그인한 계정이 총판 시용자인지 확인하기
                .filter(({ isOnlyForDistributorUser }) => (isOnlyForDistributorUser
                ? isDistUser
                : true))
                .filter(({ linkOptions }) => {
                const { pageAuthorization, isSomePermissionAvailable, } = linkOptions;
                if (!pageAuthorization || !pageAuthorization.length) {
                    return true;
                }
                if (vuexStore.getters['user/getterUserPermission'](pageAuthorization, !isSomePermissionAvailable)) {
                    return true;
                }
                return false;
            }),
    })));
}
